import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../Common/Styles/Icons.module.scss";
import { appPaths } from "../../../Common";
import { AuthoredByData } from "../..";
import { AuthorType } from "../../Constants/userEnums";

import { BadgeButton } from "../../../Layout/Components/BadgeButton/BadgeButton";

type Props = {
  authoredBy: AuthoredByData;
};

class AuthorProfileBadge extends React.Component<Props & RouteComponentProps> {
  constructor(props: Props & RouteComponentProps) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick = () => {
    // go to either user or company profile page depending on author type
    switch (this.props.authoredBy.type) {
      case AuthorType.User: {
        // redirect to user profile page
        this.props.history.push(appPaths.user.root.replace(":username", this.props.authoredBy.id));
        break;
      }
      case AuthorType.Company: {
        // redirect to company profile page
        this.props.history.push(
          appPaths.company.root.replace(":shortname", this.props.authoredBy.id)
        );
        break;
      }
      default: {
        throw new Error(`Cannot render page for author of type: ${this.props.authoredBy.type}`);
      }
    }
  };

  render() {
    const disabled = this.props.authoredBy.type === AuthorType.Anonymous;
    const title = !disabled
      ? `Click here to view the profile of ${this.props.authoredBy.name}`
      : "";

    return (
      <div onClick={e => e.stopPropagation()}>
        <BadgeButton onClick={this.handleClick} disabled={disabled} title={title}>
          <span>
            {this.props.authoredBy.type === AuthorType.User && (
              <Icon
                appName="GeneralLayout"
                assetName="GENERAL_F_UserF"
                className={iconStyles.smallIcon}
              />
            )}
            {this.props.authoredBy.type === AuthorType.Company && (
              <Icon
                appName="GeneralLayout"
                assetName="GENERAL_L_Company"
                className={iconStyles.smallIcon}
              />
            )}
          </span>
          &nbsp;
          <span>{this.props.authoredBy.name}</span>
        </BadgeButton>
      </div>
    );
  }
}

export default withRouter(AuthorProfileBadge);
